const URB = "var(--font-urbanist), sans-serif";

export default function MatchingIndicator({
  label = "Searching for the best agents…",
}: {
  label?: string;
}) {
  return (
    <div
      className="app-anim-fade-left"
      style={{
        display: "flex",
        alignItems: "center",
        gap: 10,
        padding: "6px 0",
      }}
    >
      <span
        className="app-matching-spinner"
        aria-hidden="true"
        style={{
          width: 14,
          height: 14,
          borderRadius: 9999,
          border: "2px solid rgba(134,53,246,0.25)",
          borderTopColor: "#8635F6",
          display: "inline-block",
        }}
      />
      <span
        style={{
          fontFamily: URB,
          fontWeight: 500,
          fontSize: 14,
          lineHeight: "20px",
          color: "rgba(242,240,237,0.7)",
        }}
      >
        {label}
      </span>
    </div>
  );
}
